import * as React from "react";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import CardActions from "@mui/joy/CardActions";
import CardOverflow from "@mui/joy/CardOverflow";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { add } from "../../service/clientService";
import { Button } from "primereact/button";
import DropdownApi from "../../components/DropdownApi";
import { UserSession } from "../../models/UserSession";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import { NprLookup } from "../../service/api-service";
import S3ImagePreview from "../../components/S3ImagePreview";
import { Avatar } from "primereact/avatar";
import { placeholder } from "../../assets/placeholder";
import MultiDropdownApi from "../../components/MultiDropdownApi";
import ImageS3Upload from "../../components/ImageS3Upload";
import { v4 as uuid } from "uuid";
import { addEquipment, updateEquipment } from "../../service/equipmentService";
import { InputTextarea } from "primereact/inputtextarea";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { Grid } from "@mui/material";
import { InputText } from "primereact/inputtext";
import IntervalDropdown from "../../components/IntervalDropdown";
import { TabPanel, TabView } from "primereact/tabview";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";

export default function EquipmentAdd(modalProps: any) {
  const session: UserSession = modalProps.session;

  const id = modalProps?.uuid;

  async function Add() {
    if (!name || name === "") {
      modalProps.toast.current.show({
        severity: "warn",
        summary: "Please enter equipment name",
        life: 3000,
      });
      return;
    }
    if (!equipmentType) {
      modalProps.toast.current.show({
        severity: "warn",
        summary: "Please select equipment type",
        life: 3000,
      });
      return;
    }
    let createObject: any = {
      client: session.client_id,
      name,
      description,
      equipment_type: equipmentType,
      serial_number: serialNumber,
      purchased_date: purchasedDate,
      maintenance_interval: maintenanceInterval,
      maintenance_value: maintenanceValue,
      expected_life_value: expectedLifeValue,
      expected_life_interval: expectedLifeInterval,
      maintenance_start_date: maintenanceDate,
      equipment_safe_checklist: safeEquipmentChecklist,
      equipment_risk_checklist: riskEquipmentChecklist,
      s3_key: !!file ? `equipment/${id}` : undefined,
    };
    if (price && price != "") {
      createObject.price = price;
    }
    modalProps.setGlobalLoading(true);
    addEquipment(createObject).then((r: any) => {
      modalProps.setGlobalLoading(false);
      modalProps.toast.current.show({
        severity: "success",
        summary: "Equipment Added Successfully",
        life: 3000,
      });
      modalProps.setReload(!modalProps.reload);
      modalProps.setVisible(false);
    });
  }

  const interval = [
    {
      id: "Daily",
      name: "Daily",
    },
    {
      id: "Weekly",
      name: "Weekly",
    },
    {
      id: "BI-Weekly",
      name: "BI-Weekly",
    },
    {
      id: "Monthly",
      name: "Monthly",
    },
    {
      id: "Yearly",
      name: "Yearly",
    },
  ];

  const [name, setName] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [equipmentType, setEquipmentType] = React.useState("");
  const [equipmentTypeObject, setEquipmentTypeObject] = React.useState<any>({});
  const [serialNumber, setSerialNumber] = React.useState("");
  const [price, setPrice] = React.useState("");
  const [purchasedDate, setPurchasedDate] = React.useState(new Date());
  const [maintenanceValue, setMaintenanceValue] = React.useState("");
  const [maintenanceInterval, setMaintenanceInterval] = React.useState("");
  const [expectedLifeValue, setExpectedLifeValue] = React.useState("");
  const [expectedLifeInterval, setExpectedLifeInterval] = React.useState("");
  const [maintenanceDate, setMaintenanceDate] = React.useState(new Date());
  const [safeEquipmentChecklist, setSafeEquipmentChecklist] = React.useState([""]);
  const [riskEquipmentChecklist, setRiskEquipmentChecklist] = React.useState([""]);

  const [riskAssessment, setRiskAssessment] = React.useState();
  const [photo, setPhoto] = React.useState(placeholder);
  const [file, setFile] = React.useState<File>();

  const [hazard, setHazard] = React.useState<string[]>([]);

  React.useEffect(() => {
    console.log("equipmentTypeObject == ", equipmentTypeObject);
    setMaintenanceValue(equipmentTypeObject?.maintenance_value);
    setMaintenanceInterval(equipmentTypeObject?.maintenance_interval);
    setExpectedLifeValue(equipmentTypeObject?.expected_life_value);
    setExpectedLifeInterval(equipmentTypeObject?.expected_life_interval);
    const risk = equipmentTypeObject?.risk_assessment;
    if (risk) {
      setRiskAssessment(risk);
    }
    const equipment_safe_checklist = equipmentTypeObject?.equipment_safe_checklist;
    if (equipment_safe_checklist) {
      setSafeEquipmentChecklist(equipment_safe_checklist);
    }
    const equipment_risk_checklist = equipmentTypeObject?.equipment_risk_checklist;
    if (equipment_risk_checklist) {
      setRiskEquipmentChecklist(equipment_risk_checklist);
    }
    const tempHazard: string = equipmentTypeObject?.hazard_list;
    if (tempHazard) {
      setHazard(tempHazard.split(","));
    }
  }, [equipmentType]);

  return (
    <React.Fragment>
      <TabView>
        <TabPanel header="Details">
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <FormControl>
                <ImageS3Upload
                  photo={photo}
                  setPhoto={setPhoto}
                  s3Key={`equipment/${id}`}
                  file={file}
                  setFile={setFile}
                />
              </FormControl>
            </Grid>
            <Grid item xs={8}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl sx={{ flexGrow: 1 }}>
                    <FormLabel>
                      Name<div style={{ color: "red" }}>*</div>
                    </FormLabel>
                    <FormControl
                      sx={{
                        display: { sm: "flex-column", md: "flex-row" },
                        gap: 2,
                      }}
                    >
                      <InputText
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        type="text"
                        className="p-inputtext-sm PrimeSmallInput"
                      />
                    </FormControl>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl>
                    <FormLabel>Serial Number</FormLabel>
                    <InputText
                      value={serialNumber}
                      onChange={(e) => setSerialNumber(e.target.value)}
                      type="text"
                      className="p-inputtext-sm PrimeSmallInput"
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
            <br />
            <Grid item xs={12}>
              <FormControl>
                <FormLabel>Unique ID</FormLabel>
                <FormControl
                  sx={{
                    display: { sm: "flex-column", md: "flex-row" },
                    gap: 2,
                  }}
                >
                  <InputTextarea
                    value={description}
                    placeholder="Unique ID"
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </FormControl>
              </FormControl>
            </Grid>
            <br />
            <Grid item xs={6}>
              <DropdownApi
                apiPath="equipment-type"
                optionLabel="name"
                optionValue="id"
                label="Equipment Type"
                selectedData={equipmentType}
                setSelectedData={setEquipmentType}
                setSelectedObject={setEquipmentTypeObject}
                required={true}
              />
            </Grid>
            {/* <Grid item xs={6}>
          <MultiDropdownApi apiPath='risk-assessment' optionLabel="name" optionValue='id' label='Risk' selectedData={riskAssessment} setSelectedData={setRiskAssessment} />
        </Grid> */}
            <br />
            <Grid item xs={6}>
              <FormControl>
                <FormLabel>Purchased Date</FormLabel>
                <Calendar
                  value={purchasedDate}
                  onChange={(e) => setPurchasedDate(e.value || new Date())}
                  showIcon
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl>
                <FormLabel>Last Maintenance Date</FormLabel>
                <Calendar
                  value={maintenanceDate}
                  onChange={(e) => setMaintenanceDate(e.value || new Date())}
                  showIcon
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <IntervalDropdown
                label="Maintenance"
                selectedInterval={maintenanceInterval}
                setSelectedInterval={setMaintenanceInterval}
                selectedValue={maintenanceValue}
                setSelectedValue={setMaintenanceValue}
              />
            </Grid>
            <Grid item xs={6}>
              <IntervalDropdown
                label="Expected Life"
                selectedInterval={expectedLifeInterval}
                setSelectedInterval={setExpectedLifeInterval}
                selectedValue={expectedLifeValue}
                setSelectedValue={setExpectedLifeValue}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControl sx={{ flexGrow: 1 }}>
                <FormLabel>Price</FormLabel>
                <InputText
                  value={price}
                  onChange={(e) => setPrice(e.target.value)}
                  type="number"
                  className="p-inputtext-sm PrimeSmallInput"
                />
              </FormControl>
            </Grid>
          </Grid>
        </TabPanel>
        <TabPanel header="Checklist">
          <TabView>
            <TabPanel header="Safe">
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl
                    sx={{ display: { sm: "flex-column", md: "flex-row" } }}
                  >
                    <FormLabel>Questions</FormLabel>
                    <Button
                      type="button"
                      icon="pi pi-plus"
                      label="Add"
                      className="p-button-outlined"
                      size="small"
                      style={{
                        position: "absolute",
                        right: 0,
                        padding: 10,
                        marginTop: -15,
                      }}
                      onClick={() => {
                        const updatedChecklist = [...safeEquipmentChecklist];
                        updatedChecklist.push("");
                        setSafeEquipmentChecklist(updatedChecklist);
                      }}
                    />
                  </FormControl>
                </Grid>
                {safeEquipmentChecklist.map((checklist: any, index: number) => {
                  return (
                    <Grid item xs={12} key={index}>
                      <IconField>
                        <InputIcon
                          className="pi pi-trash"
                          style={{ color: "#eb445a" }}
                          onClick={() => {
                            const updatedChecklist = [...safeEquipmentChecklist];
                            updatedChecklist.splice(index, 1);
                            setSafeEquipmentChecklist(updatedChecklist);
                          }}
                        >
                          {" "}
                        </InputIcon>
                        <InputText
                          value={checklist}
                          onChange={(e) => {
                            const updatedChecklist = [...safeEquipmentChecklist];
                            updatedChecklist[index] = e.target.value;
                            setSafeEquipmentChecklist(updatedChecklist);
                          }}
                          style={{ width: "100%" }}
                          type="text"
                          className="p-inputtext-sm PrimeSmallInput"
                          placeholder={`Please enter question ${index + 1}`}
                        />
                      </IconField>
                    </Grid>
                  );
                })}
              </Grid>
            </TabPanel>
            <TabPanel header="At Risk">
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl
                    sx={{ display: { sm: "flex-column", md: "flex-row" } }}
                  >
                    <FormLabel>Questions</FormLabel>
                    <Button
                      type="button"
                      icon="pi pi-plus"
                      label="Add"
                      className="p-button-outlined"
                      size="small"
                      style={{
                        position: "absolute",
                        right: 0,
                        padding: 10,
                        marginTop: -15,
                      }}
                      onClick={() => {
                        const updatedChecklist = [...riskEquipmentChecklist];
                        updatedChecklist.push("");
                        setRiskEquipmentChecklist(updatedChecklist);
                      }}
                    />
                  </FormControl>
                </Grid>
                {riskEquipmentChecklist.map((checklist: any, index: number) => {
                  return (
                    <Grid item xs={12} key={index}>
                      <IconField>
                        <InputIcon
                          className="pi pi-trash"
                          style={{ color: "#eb445a" }}
                          onClick={() => {
                            const updatedChecklist = [...riskEquipmentChecklist];
                            updatedChecklist.splice(index, 1);
                            setRiskEquipmentChecklist(updatedChecklist);
                          }}
                        >
                          {" "}
                        </InputIcon>
                        <InputText
                          value={checklist}
                          onChange={(e) => {
                            const updatedChecklist = [...riskEquipmentChecklist];
                            updatedChecklist[index] = e.target.value;
                            setRiskEquipmentChecklist(updatedChecklist);
                          }}
                          style={{ width: "100%" }}
                          type="text"
                          className="p-inputtext-sm PrimeSmallInput"
                          placeholder={`Please enter question ${index + 1}`}
                        />
                      </IconField>
                    </Grid>
                  );
                })}
              </Grid>
            </TabPanel>
          </TabView>
        </TabPanel>
        {
          hazard && hazard.length > 0 && (
            <TabPanel header="Hazards">
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl>
                    <FormLabel>Control Measures</FormLabel>
                    <FormControl
                      sx={{
                        display: { sm: "flex-column", md: "flex-row" },
                        gap: 2,
                      }}
                    >
                    </FormControl>
                  </FormControl>
                </Grid>
                {hazard && hazard.map((record: any, index: number) => {
                  return (
                    <Grid item xs={12} key={index}>
                      <IconField>
                        <InputText
                          value={record}
                          readOnly={true}
                          style={{ width: "100%" }}
                          type="text"
                          className="p-inputtext-sm PrimeSmallInput"
                        />
                      </IconField>
                    </Grid>
                  );
                })}
              </Grid>
            </TabPanel>
          )
        }
      </TabView>
      <br />
      <br />
      <CardOverflow
        style={{ width: "100%" }}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      >
        <CardActions
          style={{ marginTop: 15 }}
          sx={{ alignSelf: "flex-end", pt: 2 }}
        >
          <Button
            type="button"
            icon="pi pi-save"
            label="Save"
            className="p-button-outlined"
            size="small"
            style={{
              position: "absolute",
              fontSize: "small",
              right: 0,
              color: "#2dd36f",
            }}
            onClick={() => Add()}
          />
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}
